import { Map, fromJS } from 'immutable';

export function request(state, { id }) {
    return state.setIn([ 'items', id, 'settlement' ], Map({
        state: 'IN_PROGRESS'
    }));
}

export function error(state, { id, errors }) {
    return state.setIn([ 'items', id, 'settlement' ], Map({
        state: 'ERROR',
        errors: fromJS(errors)
    }));
}

export function finish(state, { id, selection }) {
    return state
        .mergeIn([ 'items', id ], fromJS(selection))
        .setIn([ 'items', id, 'settlement' ], Map({
            state: 'FINISHED'
        }));
}
